export default __webpack_public_path__ + "static/media/sign_in_1.ebd6a29e.png";